import { Component, ElementRef, ViewChild ,HostListener } from '@angular/core';
import { RouterModule ,RouterLink } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-top-nav-bar',
  standalone: true,
  imports: [RouterModule,RouterLink,ButtonModule,TieredMenuModule, CommonModule],
  templateUrl: './top-nav-bar.component.html',
  styleUrl: './top-nav-bar.component.scss'
})
export class TopNavBarComponent {
  @ViewChild('popMenu') popMenu!: ElementRef;  // Reference to the <nav> element

  items1: MenuItem[] | undefined;


  closePopup(){
    if (window.innerWidth < 912 && this.popMenu) {
      // Apply the CSS transformation to close the menu
      this.popMenu.nativeElement.style.transform = 'translateX(-100%)';
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    if (window.innerWidth < 912 && this.popMenu) {
      // Apply the CSS transformation to close the menu
      this.popMenu.nativeElement.style.transform = 'translateX(-100%)';
    }
    else{
      this.popMenu.nativeElement.style.transform = 'translateX(0)';
    }
  }

   ngOnInit() {
        this.items1 = [
            {
              label: 'Student',
              routerLink: 'signin'
            },
            {
              label: 'Staff',
              routerLink: 'staff-signin'
            }
        ]
    }

}
